import * as ActionTypes from "constants/ActionTypes";

export const setTextTrackLanguage = (language) => ({
  language,
  type: ActionTypes.SET_TEXT_TRACK_LANGUAGE,
});

export const hideTextTrackCaptionSettings = () => ({
  type: ActionTypes.SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY,
  visible: false,
});

export const showTextTrackCaptionSettings = () => ({
  type: ActionTypes.SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY,
  visible: true,
});

export const setCaptionsSelectionMenuVisibility = (visible) => ({
  type: ActionTypes.SET_CAPTIONS_SELECTION_MENU_VISIBILITY,
  visible,
});
